export const bagStatuses = {
    collected: 'collected',
    in_progress: 'in progress',
    error: 'error',
    manually_closed: 'manually closed',
};
